<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Incomplete Journey ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showIncompleteDataTable">

  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
  </span>

  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>
  
  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="w-10pct">Sr. No.</th>
          <th class="w-10pct">Cust Id</th>
          <th  class="w-22pct"> Loan Reference Number<br>
          <th  class="w-22pct">Name of Applicant <br>
          <th> Application Status<br>
          <th>Mobile Number<br>
            <th class="vertical-align-top">Date of Application</th>
            <th class="vertical-align-top" *ngIf="roleId == 1">Zone</th>
            <th class="vertical-align-top" *ngIf="roleId == 1 || roleId == 21 || roleId == 2">RO</th>
            <th class="vertical-align-top" *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31" >Branch</th>

        </tr>
      </thead>

      
      <tbody>
        <tr  *ngFor="let user of allUsers;let i = index;" >
          <td class="vertical-align-middle">
            <p>{{10 *(pageId-1)+i+1}}</p>   
          </td>
          <td class="vertical-align-middle">
            <p>{{(user.custId)? user.custId : ""}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{(user?.ubi_reference_no) ? user.ubi_reference_no : 'Loan Reference Number not available' }}</p>
          </td>
          <td class="vertical-align-middle">

            <p>{{
              (user?.profile?.first_name) ? user.profile.first_name : ""
            }}</p>
          </td>
          <td class="vertical-align-middle">
            <p >

               <!-- {{getAppStatusMessage(user.appStatus, user.trackerObj)}} -->
                {{user.application_stage ? user.application_stage : ""}}
            </p>
          </td>          

          <td class="vertical-align-middle">
            <p>{{(user?.aadhar_details?.mobile_number) ? user.aadhar_details.mobile_number : '' }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{(user?.created) ? (user.created | date:'d/M/yy') : '' }}</p>
          </td>
          <td class="text-center vertical-align-middle" *ngIf="roleId == 1">
            <p>{{user?.zone_name}}</p>
          </td>
          <td class="vertical-align-middle" *ngIf="roleId == 1 || roleId == 21 || roleId == 2">
            <p>{{user?.ro_name}}</p>
          </td>
          <td class="vertical-align-middle" *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31">
            <p>{{user?.branch_name}}</p>
          </td>
        </tr>
      </tbody>

    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1 && !this.noUserFound" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>



</wl-card>






<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />


